module.exports = __webpack_public_path__ + "static/media/screenshot_history_5_ru.0d9b3910.png";